export default {
  messages: {
    configUpdatedSuccess: 'Configuration updated successfully',
    saveSuccess: 'Save successfully',
    createSuccess: 'Created successfully',
    saveWorkflowFailed: 'Failed to save workflow',
    cloneSuccess: 'Cloned successfully',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Failed to delete',
    confirm: 'Confirm',
    cancel: 'Cancel',
    workflowStarted: 'Workflow started',
    uploadSuccess: 'Uploaded successfully',
    uploadFlowExampleFailed: 'Failed to upload workflow test example',
    updateFlowExampleFailed: 'Failed to update workflow test example',
    deleteFlowExampleFailed: 'Failed to delete workflow test example',
    saveFlowExampleFailed: 'Failed to save workflow test example',
    workflowHistorySaveFailed: 'Failed to save workflow history',
    workflowVersionNameUpdateSuccess: 'Record name updated successfully',
    workflowVersionNameUpdateFailed: 'Failed to update record name',
    workflowVersionPublishSuccess: 'Workflow version published successfully',
    workflowVersionPublishFailed: 'Failed to publish workflow version',
    workflowHistoryListFetchFailed: 'Failed to fetch workflow history list',
    workflowHistoryDetailFetchFailed:
      'Failed to fetch workflow history details',
    workflowVersionDeprecated: 'Workflow version deprecated',
    workflowVersionDeprecateFailed: 'Failed to deprecate workflow version',
    workflowVersionDeleteConfirmTitle: 'Confirm Delete',
    workflowVersionDeleteConfirmContent:
      'Are you sure you want to delete "{name}"?',
    loadWorkflowFailed: 'Failed to load workflow',
    loadWorkflowTagsFailed: 'Failed to load workflow tags',
    loadWorkflowListFailed: 'Failed to load workflow list',
    getWorkflowDetailFailed: 'Failed to get workflow details',
    collaborationDataReset: 'Collaboration data has been reset',
    collaborationResetFailed: 'Failed to reset collaboration',
    historySnapshotRestored: 'History snapshot restored',
    historySnapshotRestoreFailed: 'Failed to restore snapshot',

    // HTTP errors
    httpUnauthorized: 'Unauthorized, please log in again',
    httpForbidden: 'Access denied',
    httpNotFound: 'The requested resource does not exist',
    httpServerError: 'Internal server error',
    httpRequestFailed: 'Request failed',
    httpTimeout: 'Request timed out, please try again later',

    // Feature
    featureNotSupportedInEdition:
      'This feature is not supported in the current edition',

    // User
    logoutSuccess: 'Logged out successfully',

    // WebSocket
    wsConnectFailed:
      'WebSocket connection failed, please check if the service is running',
    wsModuleLoadFailed: 'Failed to load WebSocket connection module',
    wsNotConnected: 'WebSocket not connected, please try again later',

    // Fast experiment
    fastExperimentCompleted: 'Fast experiment completed',
    experimentError: 'Experiment error: {error}',
    inputJsonFormatError:
      'Input parameter format error, please check JSON format',
    fastExperimentStarted: 'Fast experiment started, waiting for results...',
    fastExperimentStartFailed: 'Failed to start fast experiment: {error}',
    experimentStopped: 'Experiment stopped',

    // User management
    searchUserFailed: 'Failed to search users',
    createUserFailed: 'Failed to create user',

    // Prompt template
    promptTemplateDeleteSuccess: 'Prompt template deleted successfully',
    promptTemplateDeleteFailed: 'Failed to delete prompt template',
    loadTemplateContentFailed: 'Failed to load template content',
    loadTemplateVersionFailed: 'Failed to load template version',
    pleaseSelectTemplate: 'Please select a template',
    selectTemplateFailed: 'Failed to select template',

    // JSON import
    invalidJsonData: 'Please enter valid JSON data',
    noImportableFields: 'No importable fields in JSON data',
    fieldsImportedSuccess: 'Successfully imported {count} fields',
    importFailedCheckJson: 'Import failed, please check JSON format',

    // Example
    exampleMustBeValidJson: 'Example content must be valid JSON format',

    // Node config
    pleaseSelectOrInputTemplateName:
      'Please select or enter a template name first',

    // Node template
    applyNodeTemplateFailed: 'Failed to apply node template: {error}',

    // Login/Token
    confirmLogout: 'Confirm Logout',
    loginExpired: 'Your login has expired, please log in again',
    reLogin: 'Log in Again',
    refreshTokenFailed: 'Failed to refresh token',
  },
};
